// extracted by mini-css-extract-plugin
module.exports = {"list-items":"category_list-items__3dAXl","item":"category_item__3b3yL","anchor":"category_anchor__37Hxx"};